<template>
  <div class="error">
    <IError class="error__icon" />
    <h1>
      <strong>{{ errorData.message }}</strong>
    </h1>
    <h2 v-if="errorData.subMessage">{{ errorData.subMessage }}</h2>
    <div v-if="errorData.showButton" class="btn retry" @click="refresh">{{ $t('reload') }}</div>
  </div>
</template>

<script>
import { postIssue } from '@/assets/js/mixins';
import IError from '@/components/icons/IError';

export default {
  components: {
    IError,
  },
  mixins: [postIssue],
  computed: {
    errorData() {
      return this.$store.state.display.error;
    },
  },
  methods: {
    refresh() {
      window.location.reload();
    },
  },
  mounted() {
    // Log generic error to CMS diagnostic tool ignoring IE11 error
    if (this.$iframe && this.errorData.message !== 'Please update your browser') {
      this.postIframeIssue('Something went wrong error');
    }
    if (this.errorData.hide) document.documentElement.classList.add('hide');
  },
};
</script>

<style lang="scss" scoped>
.retry {
  margin-top: 2rem;
  padding: 1rem 2rem;
  color: $white;
  background-color: $blue;
  text-align: center;
}

h2 {
  color: $grey-700;
}

.error {
  @include fit-boundaries();
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 6em 0;
  text-align: center;

  &__icon {
    margin-bottom: 1rem;
  }
}
</style>
